import { render } from "./InvoiceDetailsPage.vue?vue&type=template&id=52fecc58&ts=true"
import script from "./InvoiceDetailsPage.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__